[
  {
    "id": "SWW-M8-L303-001",
    "module": "SpellingWW",
    "difficulty": 303,
    "difficultyTier": 15,
    "levelCode": "M8",
    "group": 8,
    "question": "Hij ... elke dag op tijd. (landen)",
    "options": ["landt", "land", "landde", "gelandt"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tegenwoordige_tijd",
    "subSkill": "tt_pv_stam_plus_t",
    "familyId": "SWW-TT-HIJ-ZIJ-HET-STAM_PLUS_T",
    "conceptId": "present_tense_third_person_add_t",
    "variantIndex": 1,
    "explanation": "Onderwerp is 'hij', dus tegenwoordige tijd persoonsvorm is stam + t.\nHele werkwoord: landen. Stam: land.\nStam + t: land + t = landt.",
    "distractorExplanations": {
      "1": "Dit is de ik-vorm: 'ik land'. Bij 'hij' komt er een t achter: landt.",
      "2": "Dit is verleden tijd. In de zin staat 'elke dag', dat wijst op tegenwoordige tijd.",
      "3": "Dit is geen juiste spelling van het voltooid deelwoord. Het voltooid deelwoord is 'geland'. Bovendien past een voltooid deelwoord hier niet zonder 'heeft/is'."
    }
  },
  {
    "id": "SWW-M8-L303-002",
    "module": "SpellingWW",
    "difficulty": 303,
    "difficultyTier": 15,
    "levelCode": "M8",
    "group": 8,
    "question": "Het pakket ... gisteren bezorgd. (worden)",
    "options": ["werd", "word", "wordt", "geworden"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "werkwoordvormen",
    "subSkill": "pv_verleden_tijd_onregelmatig",
    "familyId": "SWW-PV-ONREGELMATIG-WERDEN",
    "conceptId": "irregular_verb_worden_past_tense",
    "variantIndex": 1,
    "explanation": "Door 'gisteren' kies je verleden tijd.\nVan 'worden' is de verleden tijd: werd (en meervoud: werden).\nDus: Het pakket werd gisteren bezorgd.",
    "distractorExplanations": {
      "1": "Dit is tegenwoordige tijd ik-vorm ('ik word'). Door 'gisteren' moet het verleden tijd zijn: werd.",
      "2": "Dit is tegenwoordige tijd bij hij/zij/het ('het wordt'). Maar 'gisteren' maakt het verleden tijd: werd.",
      "3": "Dit is het voltooid deelwoord van 'worden' en gebruik je met 'is/heeft': 'Het is geworden'. Hier staat al 'bezorgd' als voltooid deelwoord; je hebt de persoonsvorm nodig: werd."
    }
  },
  {
    "id": "SWW-M8-L303-003",
    "module": "SpellingWW",
    "difficulty": 303,
    "difficultyTier": 15,
    "levelCode": "M8",
    "group": 8,
    "question": "Zij ... haar huiswerk al. (maken)",
    "options": ["maakte", "maakt", "maakten", "gemaakt"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "werkwoordvormen",
    "subSkill": "pv_verleden_tijd_context",
    "familyId": "SWW-PV-TIJD-KEUZE-CONTEXT",
    "conceptId": "choose_past_tense_from_context",
    "variantIndex": 1,
    "explanation": "Het woord 'al' kan bij meerdere tijden, maar de bedoeling is vaak: het gebeurde eerder (verleden tijd) zonder hulpwerkwoord.\nOnderwerp is 'zij' (enkelvoud) en er staat maar één werkwoordsvormplek.\nVerleden tijd van 'maken' is: maakte.",
    "distractorExplanations": {
      "1": "Dit is tegenwoordige tijd. Als je de zin bedoelt als iets dat al gebeurd is (en je gebruikt geen 'heeft'), dan kies je verleden tijd: maakte.",
      "2": "Dit is meervoud verleden tijd ('zij maakten' = meerdere personen). Hier is 'zij' enkelvoud (zij = zijzelf).",
      "3": "Dit is het voltooid deelwoord en hoort met 'heeft': 'Zij heeft haar huiswerk al gemaakt'. Zonder 'heeft' kan 'gemaakt' niet op deze plek."
    }
  },
  {
    "id": "SWW-M8-L303-004",
    "module": "SpellingWW",
    "difficulty": 303,
    "difficultyTier": 15,
    "levelCode": "M8",
    "group": 8,
    "question": "De computer is gisteren ... (updaten).",
    "options": ["geüpdatet", "geüpdated", "geupdate", "updatete"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "voltooid_deelwoord",
    "subSkill": "leenwerkwoord",
    "familyId": "SWW-LEENWW-VD-TEDE-OP_KLANK",
    "conceptId": "loanword_past_participle_te_rule",
    "variantIndex": 1,
    "explanation": "Na 'is' hoort een voltooid deelwoord.\nBij leenwerkwoorden kijk je naar de eindklank: 'update' eindigt op een t-klank.\nDan krijgt het voltooid deelwoord een t: geüpdatet.\nDit is de gebruikelijke Nederlandse spelling in dit soort oefenvragen.",
    "distractorExplanations": {
      "1": "Dit kiest d terwijl de eindklank een t-klank is. Bij t-klank hoort t, dus geüpdatet.",
      "2": "Dit mist de t aan het eind. Na 'is' heb je een voltooid deelwoord nodig en dat eindigt hier op t: geüpdatet.",
      "3": "Dit is verleden tijd (updatete). In de zin met 'is' gebruik je voltooid deelwoord: is geüpdatet."
    }
  },
  {
    "id": "SWW-M8-L303-005",
    "module": "SpellingWW",
    "difficulty": 303,
    "difficultyTier": 15,
    "levelCode": "M8",
    "group": 8,
    "question": "Hij ... de groep door het museum. (leiden)",
    "options": ["leidt", "leid", "leidde", "geleid"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tegenwoordige_tijd",
    "subSkill": "tt_pv_dt",
    "familyId": "SWW-TT-DT-PV",
    "conceptId": "present_tense_third_person_dt",
    "variantIndex": 1,
    "explanation": "Onderwerp is 'hij', dus je gebruikt stam + t.\nHele werkwoord: leiden. Stam: leid.\nStam + t: leidt.",
    "distractorExplanations": {
      "1": "Dit is de ik-vorm: 'ik leid'. Bij 'hij' moet er een t achter: leidt.",
      "2": "Dit is verleden tijd. In de zin gaat het om wat hij nu doet: hij leidt de groep.",
      "3": "Dit is het voltooid deelwoord en hoort met 'heeft/is': 'Hij heeft geleid'. Hier heb je de persoonsvorm nodig: leidt."
    }
  }
]
